import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FinesService } from 'src/app/core/services/fines.service';


interface AssessmentAccount {
  mde_name: string;
  mde_questionaireaccountsid: string;
}

@Component({
  selector: 'app-fines-select',
  templateUrl: './fines-select.component.html',
  styleUrls: ['./fines-select.component.css']
})
export class FinesSelectComponent implements OnInit {
  isArabic!: boolean;
  assessmentAccounts: AssessmentAccount[] = [];
  form!: FormGroup;
  finesList: any[] = [];
  userData: any;
 
  constructor(
    private router: Router,
    private storageService: StorageService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private finesService: FinesService
  ) {}

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.form = this.fb.group({
      fines: [''] // default empty
    });
    const requestData = {
      assessmentUnitGuid: this.userData?.assessmentUnitValue,
    };
    this.finesService.fetchFinesList(requestData).subscribe((res) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.finesList = resp;
        if (this.finesList.length > 0) {
          this.storageService.setSessionStorageData('finesCount', this.finesList.length);
          this.form.patchValue({
            fines: this.finesList[0].mde_questionaireaccountsid
          });
        } else {
          this.form.patchValue({ fines: '' });
        }
      }
    }, 
    (error: any) => { 
      console.error('Error fetching fines list', error);
      this.form.patchValue({ fines: '' });
    });
  }

  goToDetail() {
    const selectedId = this.form.get('fines')?.value;
    this.storageService.setSessionStorageData('finesId', selectedId);
    this.storageService.removeSessionStorageData('finesHistorical');
    if (selectedId) {
      this.router.navigate(
        ['/executor-dashboard/fines/detail'],
        { state: { finesId: selectedId } }
      );
    } else {
      alert('Please select an assessment first.');
    }
  }
}
